<template>
  <div class="modal-window mas013">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.NewProject.001","과제 추가") }}</div>
      <button @click="closePopup" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt">{{$i18nUtil.trans("message.NewProject.001","과제를 수행할 협업 공간을 생성해보세요.")}}</div>
      <div class="input-box tit">
        <input
          type="text"
          v-model="title"
          required
          :placeholder='$i18nUtil.trans("entity.project","과제")'
        />
        <div class="error" v-if="titleError != ''">{{ titleError }}</div>
      </div>
      <div class="calendar_box_grp">
        <div class="calendar_box">
          <datepicker
            format="yyyy.MM.dd"
            v-model="startDate"
            :placeholder="$i18nUtil.trans('message.placeholder.select.startDate','시작일 선택')"
          ></datepicker>
        </div>
        <span>~</span>
        <div class="calendar_box">
          <datepicker
            format="yyyy.MM.dd"
            v-model="endDate"
            :placeholder="$i18nUtil.trans('message.placeholder.select.endDate','종료일 선택')"
          ></datepicker>
        </div>

        <button
          type="button"
          class="btn-refresh"
          @click="dateReset"
          v-if="startDate || endDate"
        >
          새로고침
        </button>
      </div>

      <div class="scroll" v-if="tenantId != 201">
        <div class="inner">
          <div>* {{$i18nUtil.trans("message.NewProject.003","과제 신설 정책 동의")}}</div>
          <ol>
            <li>
              {{$i18nUtil.trans("message.NewProject.004","1. 과제 신설")}}
              <ol>
                <li>
                  {{$i18nUtil.trans("message.NewProject.005","① 과제 만들기는 사내 업무 및 활동을 원활하게 할 수 있도록 하기 위함이며, 개인 백업용도 등의 사적인 용도를 위해 사용하지 않습니다.")}}
                </li>
              </ol>
            </li>
            <li>
              {{$i18nUtil.trans("message.NewProject.006","2. 과제 폐쇄")}}
              <ol>
                <li>
                  {{$i18nUtil.trans("message.NewProject.007","① 과제에 1년간 접근 기록이 없을 경우, 해당 과제는 자동 폐쇄됩니다.")}}
                </li>
              </ol>
            </li>
            <li>
              {{$i18nUtil.trans("message.NewProject.008","3. 과제멤버 설정")}}
              <ol>
                <li>
                  {{ $i18nUtil.trans("message.NewProject.009","① 과제 멤버 설정은 개설 완료 후 과제 상단 ●●●(더보기) 과제정보관리에서 할 수 있습니다.") }}
                </li>
              </ol>
            </li>
            <li>
              {{ $i18nUtil.trans("message.NewProject.010","4. 과제 내 업로드 불가능한 자료 범위") }}
              <ol>
                <li>{{ $i18nUtil.trans("message.NewProject.011","① 개인정보보호법 위반") }}</li>
                <li>{{ $i18nUtil.trans("message.NewProject.012","② 회사비밀 (대외비 포함)") }}</li>
                <li>
                  {{ $i18nUtil.trans("message.NewProject.013","③ 저작권 등 다른 사람의 권리를 침해하거나 명예를 훼손하는 게시물") }}
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
      <div class="scroll" v-if="tenantId == 201">
        <div class="inner">
          <div>* {{$i18nUtil.trans("message.NewProject.003","과제 신설 정책 동의")}}</div>
          <ol>
            <li>
              {{$i18nUtil.trans("message.NewProject.004","1. 과제 신설")}}
              <ol>
                <li>
                  {{$i18nUtil.trans("message.NewProject.005","① 과제 만들기는 사내 업무 및 활동을 원활하게 할 수 있도록 하기 위함이며, 개인 백업용도 등의 사적인 용도를 위해 사용하지 않습니다.")}}
                </li>
              </ol>
            </li>
            <li>
              {{$i18nUtil.trans("message.NewProject.008","2. 과제멤버 설정")}}
              <ol>
                <li>
                  {{ $i18nUtil.trans("message.NewProject.009","① 과제 멤버 설정은 개설 완료 후 과제 상단 ●●●(더보기) 과제정보관리에서 할 수 있습니다.") }}
                </li>
              </ol>
            </li>
            <li>
              {{ $i18nUtil.trans("message.NewProject.010","3. 과제 내 업로드 불가능한 자료 범위") }}
              <ol>
                <li>{{ $i18nUtil.trans("message.NewProject.011","① 개인정보보호법 위반") }}</li>
                <li>{{ $i18nUtil.trans("message.NewProject.012","② 회사비밀 (대외비 포함)") }}</li>
                <li>
                  {{ $i18nUtil.trans("message.NewProject.013","③ 저작권 등 다른 사람의 권리를 침해하거나 명예를 훼손하는 게시물") }}
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
      <div class="agree clear">
        <input
          type="checkbox"
          name=""
          id="agree"
          v-model="policyChecked"
        /><label for="agree">{{$i18nUtil.trans("message.NewProject.014","위의 과제 만들기 정책에 동의합니다.")}}</label>
        <div class="fr error" v-if="policyError">
          {{$i18nUtil.trans("message.NewProject.015","과제 만들기 정책에 동의합니다.")}}
        </div>
      </div>
      <footer class="modal-footer">
        <button type="button" class="btn_ty1" @click="projectNameCheck">
          {{ $i18nUtil.trans("button.register","등록") }}
        </button>
        <!-- <button type="button" class="btn_ty1" @click="registProject">
          등록
        </button> -->
      </footer>
    </div>
  </div>
</template>
<script>
// import Datepicker from "vuejs-datepicker";
import { mapState, mapActions, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import LinkedOkr from "./LinkedOkr";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      okrUse: localStorage.getItem("okrUse"),
      isOkrList: false,
      projectId: "",
      param: {},
      disabledEndDate: "",
      titleError: "",
      policyError: false,
      policyChecked: [],
      title: "",
      startDate: "",
      endDate: "",
      contents: "",
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  watch: {
    startDate: function () {
      this.dateCheck("start");
    },
    endDate: function () {
      this.dateCheck("end");
    },
    title: function () {
      let byte = 0;

      for (let i = 0; i < this.title.length; ++i) {
        // 기본 한글 2바이트 처리
        this.title.charCodeAt(i) > 127 ? (byte += 2) : byte++;
      }
      if (byte > 100) { /* 60 -> 100 bytes 수정 */
        this.titleError = this.$i18nUtil.trans("UB008", {
          textLength: this.title.length,
          byteLength: byte,
          maxByteLength: 100,
        });
        // "입력 가능한 글자수를 초과하였습니다. [" +
        // this.title.length +
        // "자 / " +
        // byte +
        // "Byte / 60Byte]";
      } else if (this.title.length == 0) {
        this.titleError = this.$i18nUtil.trans("UB001");
      } else {
        this.titleError = "";
      }
    },
    policyChecked: function () {
      if (this.policyChecked.length == 0) {
        this.policyError = true;
      } else {
        this.policyError = false;
      }
    },
  },
  created() {
    let body = document.querySelector("body");
    body.style.overflow = "hidden";
    let date = new Date();
    date.setDate(date.getDate() - 1);
    this.disabledEndDate = date;
  },
  mounted() {
    // 임시 okr 미사용
    // this.getCountOkrList();
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", [
      "COWORK_REST_ACTION",
      "COWORK_REST_SIMPLE_ACTION",
    ]),

    getTodayDate() {
      this.startDate = new Date();
      this.endDate = new Date();
    },
    registProject() {
      const start = this.startDate == "" ? "" : this.changeDate(this.startDate);
      const end = this.startDate == "" ? "" : this.changeDate(this.endDate);
      let obj = this;
      let reqData = {
        url: "/api/cogroup/project/registProject",
        method: "post",
        params: {
          projectName: obj.title,
          listType: "Simple",
          startDate: start,
          endDate: end,
          groupDesc: "",
          groupKbn: "PRO",
          okrCommand: "",
        },
      };
      this.loader = this.$loading.show();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((data) => {
          if (data.errorCode) {
            console.log(data.errorCode);
          } else {
            obj.projectId = data.result.projectId;

            if (obj.isOkrList && this.okrUse) {
              obj.showConfirmDialog(
                { width: "400px" },
                obj.$i18nUtil.trans("title.dialog.notice","알림"),
                obj.$i18nUtil.trans("AB074", "과제가 생성되었습니다. OKR과 하위 OKR 멤버를 과제에 추가하여 관리해보세요. 진행하시겠습니까?"),
                obj.$i18nUtil.trans("button.dialog.progress","진행"),
                obj.buttonCallBack,
                null,
                obj.$i18nUtil.trans("button.dialog.no","아니오"),
                obj.subButtonCallback
              );
              obj.param = {
                view: "LinkedOkr",
                projectData: {
                  projectId: data.result.projectId,
                  groupId: data.result.groupId,
                  projectName: this.title,
                  startDate: this.startDate,
                  endDate: this.endDate,
                  publicYn: "1",
                  projectId: data.result.projectId,
                },
              };
            } else {
              let body = document.querySelector("body");
              body.style.removeProperty("overflow");
              obj.$emit("close");
              this.$router.replace(
                "/general/dashboard/" + data.result.projectId
              );
            }

            obj.loader.hide();
          }
        })
        .catch((err) => {
          alert("등록실패");
        });
    },
    getCountOkrList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getCountOkrList",
        method: "post",
        params: {},
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((data) => {
          console.log("okr 갯수", data.result);
          if (!data.errorCode) {
            obj.isOkrList = data.result;
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("getCountOkrList fail");
        });
    },
    buttonCallBack() {
      this.$emit("updateView", this.param);
    },
    subButtonCallback() {
      this.$emit("close");
      this.$router.replace("/general/dashboard/" + this.projectId);
    },
    changeDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const days = date.getDate();
      const currentTime =
        year.toString() +
        (month > 9 ? month : "0" + month).toString() +
        (days > 9 ? days : "0" + days).toString();
      return currentTime;
    },
    dateCheck(type) {
      // if (this.startDate == null || this.endDate == null) {
      //   return;
      // }
      if (
        this.startDate > this.endDate ||
        this.startDate == "" ||
        this.endDate == ""
      ) {
        if (type == "start") {
          this.endDate = this.startDate;
        } else {
          this.startDate = this.endDate;
        }
      }
    },
    projectNameCheck() {
      if (this.title.length == 0) {
        this.titleError = this.$i18nUtil.trans("UB001");
        return;
      }
      if (this.titleError) {
        return;
      }
      if (this.policyChecked.length == 0) {
        this.policyError = true;
        return;
      }
      let obj = this;

      let regex =/[\"\\"/"\[\]\:\|\<\>\+\=\;\,\?\*\'\@]/g;
      let result = regex.exec(this.title);
      if(result != null){
        obj.showAlertDialog(obj.$i18nUtil.trans("AB109"));
        return;
      }

      let reqData = {
        url: "/api/cogroup/cogroup/checkCoGroupName",
        method: "post",
        params: {
          groupName: this.title,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if (res.result > 0) {
              obj.titleError = this.$i18nUtil.trans("UB023");
            } else {
              obj.titleError = "";
              obj.registProject();
            }
          }
        })
        .catch((err) => {
          console.log("체크 실패");
        });
    },
    dateReset() {
      this.startDate = "";
      this.endDate = "";
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      this.$emit("close");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/NewProject.vue